export default __webpack_public_path__ + "static/media/NavLogoReversed.eccb97e7.svg";